import React, {Component} from 'react'
import 'react-responsive-modal/styles.css'
import {Modal} from 'react-responsive-modal'
import LaddaButton from './LaddaButton'
// import Toggle from 'react-toggle'
import 'react-toggle/style.css'
import {Redirect} from 'react-router-dom'
import moment from 'moment'

class SettingsModal extends Component {
  onCloseModal = () => {
    this.props.onClose && this.props.onClose()
  }

  render() {
    const {open} = this.props
    const {membership, expiring} = this.props
    let user = this.props.currentUser
    let endDate = membership && moment(new Date(membership.end.seconds * 1000)) || undefined
    console.info(membership)
    window.moment = moment
    // let start = moment(membership.start * 1000)
    // let end = moment(membership.start * 1000)

    return (
      <Modal open={open} onClose={this.onCloseModal}>
        <h2 className="black" key="h2">
          Settings for {user && user.displayName}
        </h2>
        <h2 className="black" >Membership expires {expiring ? 'soon:' : 'on:'}</h2>
        {membership && <div className="black" >{endDate.format('DD/MM/YYYY')}</div>}
        <br/>
        <LaddaButton onClick={this.props.logout}>Log Out</LaddaButton>
      </Modal>
    )
  }
}

export default SettingsModal



// WEBPACK FOOTER //
// ./src/components/SettingsModal.jsx